import {UserDropdownEventType} from '@yandex-data-ui/common';
import {getAuthHref} from 'ui/utils/getAuthUrl';

const {cloud} = window.YC;

export const getRetpathUrl = (event: UserDropdownEventType) => {
    if (cloud && [UserDropdownEventType.AccountLogin].includes(event)) {
        return `${location.pathname}${location.search}`;
    }
    if (cloud && [UserDropdownEventType.SwitchUser].includes(event)) {
        return window.location.origin + getAuthHref();
    }
    return window.location.href;
};
